/**
 * Single source of truth for the canonical site origin.
 *
 * The default is the www host because that's the canonical form Vercel
 * serves. Set NEXT_PUBLIC_SITE_URL in the environment to override (e.g.
 * preview deployments). Trailing slashes are stripped so callers can
 * always concatenate `${SITE_URL}/path`.
 */
export const SITE_URL = (
  process.env.NEXT_PUBLIC_SITE_URL || 'https://www.appstoretracker.com'
).replace(/\/+$/, '');

export const NEWSLETTER_URL = 'https://appstoretimes.beehiiv.com';
export const X_PROFILE_URL = 'https://x.com/appstoretracker';

/**
 * Map of country code → BCP-47 locale tag, used to emit hreflang
 * alternates on country-segmented pages. Keep in sync with COUNTRIES in
 * src/lib/constants.ts.
 */
export const LOCALES: Record<string, string> = {
  us: 'en-US',
  gb: 'en-GB',
  fr: 'fr-FR',
  de: 'de-DE',
  br: 'pt-BR',
};

/** The country code whose URL should also serve as hreflang x-default. */
export const X_DEFAULT_COUNTRY = 'us';
